/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-24 18:08:33
 * @Description: 维保计划路由
 */
const wbjhRoutes = {
  path: 'wbjh',
  name: 'wbjh',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'wbjhIndex',
      component: () => import(/* webpackChunkName: "wbjkList" */'@/features/xfwbgl/wbjh/index.vue'),
      meta: {
        navtabTitle: '维保计划管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: [
          { elementCode: 'wbxmManage_search', elementName: '查询' },
          { elementCode: 'wbxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'wbxm_scbg', elementName: '生成报告' },
          { elementCode: 'wbxm_sqxg', elementName: '申请修改' },
          { elementCode: 'wbxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'list/:xmId',
      name: 'wbjhList',
      component: () => import(/* webpackChunkName: "wbjkList" */'@/features/xfwbgl/wbjh/wbjhList.vue'),
      meta: {
        navtabTitle: '维保计划管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'view/:id',
      name: 'viewWbjh',
      component: () => import(/* webpackChunkName: "viewWbjh" */'@/features/xfwbgl/wbjh/detail/index.vue'),
      meta: {
        navtabTitle: '查看计划',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default wbjhRoutes;
